import {
  ICategorySoldProducts,
  ISoldProducts,
} from 'legacy/lut/classes/models/partner360/ELT/IELTFormData'
import { isCategoryChecked } from 'legacy/lut/components/widgets/public/partner360/ELT/ui/soldProducts/checkBoxThree/helpers/isCategoryChecked'
import { isCategoryIndeterminate } from 'legacy/lut/components/widgets/public/partner360/ELT/ui/soldProducts/checkBoxThree/helpers/isCategoryIndeterminate'
import { isProductChecked } from 'legacy/lut/components/widgets/public/partner360/ELT/ui/soldProducts/checkBoxThree/helpers/isProductChecked'
import { CheckboxTranslated } from 'legacy/lut/components/widgets/public/partner360/ELT/ui/soldProducts/checkboxTranslated/CheckboxTranslated'

import styles from './CheckBoxThree.module.scss'

interface IProps {
  staticData: ICategorySoldProducts[]
  selectedData: ICategorySoldProducts[]
  onCheckProducts: (product: ISoldProducts, productCategory: ICategorySoldProducts) => void
  onCheckCategory: (productCategory: ICategorySoldProducts) => void
}

export const CheckBoxThree = ({
  staticData,
  onCheckProducts,
  selectedData,
  onCheckCategory,
}: IProps) => {
  return (
    <div className={styles.root}>
      {staticData.map((category) => {
        return (
          <div key={category.Key}>
            <div className={styles.title}>
              <CheckboxTranslated
                isIndeterminate={isCategoryIndeterminate({
                  selectedData,
                  categoryKey: category.Key,
                  staticData,
                })}
                checked={isCategoryChecked({ selectedData, categoryKey: category.Key, staticData })}
                label={category.Name}
                onChange={() => onCheckCategory(category)}
              />
            </div>
            <div className={styles.products}>
              {category.Products.map((product) => {
                return (
                  <CheckboxTranslated
                    key={product.Key}
                    checked={isProductChecked({
                      selectedData,
                      productKey: product.Key,
                      categoryKey: category.Key,
                    })}
                    label={product.Name}
                    onChange={() => onCheckProducts(product, category)}
                  />
                )
              })}
            </div>
          </div>
        )
      })}
    </div>
  )
}
